import React, { Component, Fragment }  from 'react';
import { connect } from 'react-redux';

import * as constants from '../../constants'
import * as libraryControlActions from '../../actions/library_control'
import SemanticUiModal from '../modal';

import { CreateControlModalContent, CreateControlModalActions } from './create_control_components';
import { debounce, getText } from '../../helpers';

import 'semantic-ui-css/semantic.min.css';
import '../../App.css';
import './index.css';

class CreateControlModal extends Component {
  constructor(props){
    super(props);
    this.state = {
      translations: props.language.translations,
      control: { is_library_control: true, tag_list: [] },
      libraryControls: [],
      selectedLibraryControls: [],
      filters: {
        include_archived: false,
        search_term: "",
        page: 1,
        include_translation: true
      },
      isfetchingLibraryControls: false
    },
    this.controlsSearchTimer = null;
  }

  componentDidMount = () => {
    this.getLibraryControls();
  } 

  componentWillReceiveProps = (nextProps) => {
    this.handleLanguageChanges(nextProps);

    const prevActionType = this.props.library_control.action_type;
    const nextActionType = nextProps.library_control.action_type;
    if (prevActionType === nextActionType) return;

    this.handleGetLibraryControlsRequest(nextProps);
    this.handleGetLibraryControlsSuccess(nextProps);
    
  };

  handleLanguageChanges = (nextProps) => {
    if (nextProps.language !== this.props.language){
      this.setState({
        translations: nextProps.language.translations
      })
    }
  }

  handleGetLibraryControlsRequest = (nextProps) => {
    const nextActionType = nextProps.library_control.action_type;

    if (nextActionType === constants.GET_LIBRARY_CONTROLS_REQUEST) {
      this.setState({ isfetchingLibraryControls: true });
    }
  }

  handleGetLibraryControlsSuccess = (nextProps) => {
    let { libraryControls, filters } = this.state;

    const nextActionType = nextProps.library_control.action_type;

    if (nextActionType === constants.GET_LIBRARY_CONTROLS_SUCCESS) {
      if (filters.page === 1) {
        libraryControls = nextProps.library_control.library_controls;
      } else {
        libraryControls = libraryControls.concat(nextProps.library_control.library_controls);
      }

      this.setState({ libraryControls, isfetchingLibraryControls: false });
    }
  }

  handleControlTypeChange = (e, { value }) => {
    var control = this.state.control;
    control.is_library_control = value === 'library';
    this.setState({ control });
  }

  setAsSelectedControl = (selectedLibraryControl) => {
    let selectedLibraryControls = this.state.selectedLibraryControls
    const isAlreadySelected = selectedLibraryControls.some(({ id }) => id === selectedLibraryControl.id)

    if(isAlreadySelected) {
      selectedLibraryControls = selectedLibraryControls.filter(({ id }) => id !== selectedLibraryControl.id)
    } else {
      selectedLibraryControls.push(selectedLibraryControl)
    }
    this.setState({ selectedLibraryControls });
  }

  getLibraryControls = () => {
    const { filters } = this.state;
    this.props.getLibraryControls(filters)
  }

  getMoreLibraryControls = () => {
    const { filters } = this.state;
    filters.page++
    this.setState({ filters }, this.getLibraryControls)
  }

  handleSearchChange = (event, data) => {
    const { filters } = this.state;
    filters.search_term = data.value;
    filters.page = 1;
    this.setState({ filters, libraryControls: [] }, this.getLibraryControls );
  }

  onSaveControl = () => {
    const { selectedLibraryControls, control } = this.state;
    if (control.is_library_control) {
      this.props.createLibraryControls(selectedLibraryControls);
    } else {
      this.props.createCustomControl(control)
    }
  }

  handleControlNameChange = (event) => {
    const { control } = this.state;
    control.name = event.target.value;
    this.setState({control});
  }

  debouncedHandleSearchChange = (e) => {
    const value = e.target.value;
    this.controlsSearchTimer = debounce(
      () => this.handleSearchChange(null, { value }),
      1000,
      this.controlsSearchTimer
    )();
  };

  render() {
    const { selectedLibraryControls, control, isfetchingLibraryControls } = this.state;
    const modalOptions = { className: "create-control-modal", size: "large" }
    const disableSave = control.is_library_control? selectedLibraryControls.length === 0: !Boolean(control.name && control.name.trim());

    return (
      <SemanticUiModal
        modalOptions={modalOptions}
        header={getText("Create Control")}
        content={
          <CreateControlModalContent
            control={this.state.control}
            libraryControls={this.state.libraryControls}
            selectedLibraryControls={this.state.selectedLibraryControls}
            handleControlTypeChange={this.handleControlTypeChange}
            handleSearchChange={this.debouncedHandleSearchChange}
            getMoreLibraryControls={this.getMoreLibraryControls}
            setAsSelectedControl={this.setAsSelectedControl}
            handleControlNameChange={this.handleControlNameChange}
            instanceConfig={this.props.instanceConfig}
            isfetchingLibraryControls={isfetchingLibraryControls}
          />
        }
        actions={
          <CreateControlModalActions
            disableSave={disableSave}
            onSaveControl={this.onSaveControl}
            hideCreateControl={this.props.hideCreateControl}
          />
        }
        closeModal={this.props.hideCreateControl}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.language.language,
    library_control: state.library_control,
    instanceConfig: state.instance.instanceConfig,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getLibraryControls: (options) => {
      dispatch(libraryControlActions.getLibraryControls(options))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateControlModal);


// WEBPACK FOOTER //
// ./src/components/controls_component/create_control_modal.js